module.exports = __webpack_public_path__ + "static/media/poll-people.1732d99a.svg";